import React from 'react';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { AdminDesc, MemberDesc } from './RolesDescription';

interface Props {
  value: boolean;
  name: string;
  handleChange: (object: { target: { value: boolean; name: 'is_admin' } }) => void;
}

const UserRightField: React.FC<Props> = ({ value, name, handleChange }) => {
  return (
    <div className="space-y-4 mb-4">
      <RadioGroup
        name={name}
        className="flex flex-row items-center"
        value={String(value)}
        onChange={(_, v) => {
          handleChange({
            target: { value: v === 'true', name: 'is_admin' },
          });
        }}
      >
        <FormControlLabel
          value="false"
          control={<Radio color="primary" />}
          label={<Typography variant="caption">Member</Typography>}
        />
        <FormControlLabel
          value="true"
          control={<Radio color="primary" />}
          label={<Typography variant="caption">Admin</Typography>}
        />
      </RadioGroup>
      <div className="max-w-[240px]">{value ? <AdminDesc /> : <MemberDesc />}</div>
    </div>
  );
};
UserRightField.displayName = 'Settings.Profile.UserRightField';

export default UserRightField;
